import React from 'react';
import { useState, useEffect,useMemo } from "react";
import Swal from "sweetalert2";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { useCookies } from 'react-cookie';
import TableRowsGRN from './TableRowsGRN';
// import {displayErrorToast} from '../../helpers';
import ErrorToast from '../../ErrorToast';
import { getAllTax } from "../../services/TaxServices";
import { getAllProducts } from '../../services/ProductServices';
import { getUserAllowedPlants, getPlantDetails} from '../../services/PlantServices'
import FloatingControls from '../../components/FloatingControls';
import { getDisplayDate } from '../../utils/DateUtils';
import {displayErrorToast,parseBoolean,displayError,mapUniqueSelectOptions} from '../../helpers';
import SummaryIcon from '../../components/SummaryIcon';
import ReactTablePopUpSubmitWrapper from '../../components/ReactTablePopUpSubmitWrapper';
import QuestionIcon from '../../components/QuestionIcon';
import { getHTMLForSummaryPopup } from '../../utils/PopupUtils';
import { getAllVendors,getVendorDetails } from '../../services/VendorServices';
import {getGoodsReceiptnumber,createGoodsReceiptNote,getCustomerVehicles,getTransporterNames,uploadPendingGrnDocuments } from '../../services/GoodsReceiptNoteServices';
import { getpurchaseorderforgrn } from '../../services/PurchaseOrderServices';
import EditSharpIcon from '@mui/icons-material/EditSharp'
import { getAllEquipments } from '../../services/EquipmentServices';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import "../../button.css";
import { getCurrentTime } from '../../utils/DateUtils';
import PremiumPageHeader from '../../components/PremiumPageHeader';
import {
    hasGrnWeighment,
    syncGrnLineWithoutWeighment,
    syncGrnLineWithWeighment,
    toGrnFloat,
} from '../../utils/grnLineUtils';
import GrnUploadCentreModal from './GrnUploadCentreModal';
import { revokePendingGrnDocument } from './grnDocumentUtils';

function GoodsReceiptNote(){
    const [cookies] = useCookies(['myToken']);
    const [category] = useCookies(['myCategory']);
    const [superuser] = useCookies(['mySuperuser']);
    const [inputs, setInputs] = useState({
        vendor_id:'',
        grn_no:'',
        grn_date:'',
        prefix:'',
        order_no:'',
        order_date:'',
        transporter_name:'',
        vehicle_id:'',
        vehicle_others:'',
        transporter_mode:'',
        driver_name:'',
        driver_mobile_no:'',
        in_time:getCurrentTime(),
        out_time:getCurrentTime(),
        weighment_name:'',
        weighment_slip_no:'',
        weighment_slip_date:'',
        weighment_slip_time:getCurrentTime(),
        measurement_taken_by:'',
        authorised_by:'',
        received_by:'',
        lr_no:'',
        lr_dt:'',
        other_doc_no:'',
        other_doc_dt:'',
        terms_and_condition:'',
        pay_terms:'0',
        is_tax_included:true,
        status:true,
        remarks:'',
        receipt_mode:'po',
    });
    const [companyName, setCompanyName] = React.useState('');
    const [plant, setplant] = React.useState([]);
    const [vendor, setvendor] = React.useState([])
    const [taxes, setTaxes] = React.useState([]);
    const [maxDate, setMaxDate] = React.useState("");
    const [products, setProducts] = React.useState([]);
    const [equipments, setEquipment] = React.useState([]);
    const [selectedVendor,setSelectedVendor] = useState({});
    const [selectedOption, setSelectedOption] = useState(null);
    const [allPurchaseOrders,setAllPurchaseOrders] = useState([]);
    const initial_table_data = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(initial_table_data);
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedPurchaseOrder,setSelectedPurchaseOrder] = useState({});
    const [rowsData, setRowsData] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [customerVehicles, setCustomerVehicles] = useState([]);
    const [transporterNames, setTransporterNames] = useState([]);
    const [selectedTransporter, setSelectedTransporter] = useState(null);
    const [showUploadCentre, setShowUploadCentre] = useState(false);
    const [grnDocuments, setGrnDocuments] = useState([]);
    const grnDocumentsRef = React.useRef([]);
    grnDocumentsRef.current = grnDocuments;

    useEffect(() => {
        return () => {
            grnDocumentsRef.current.forEach(revokePendingGrnDocument);
        };
    }, []);

    React.useEffect(() => {
        getUserAllowedPlants(cookies)
        .then (
            plantList => {
                const plant = plantList.plant_list.filter(obj => obj.status).map(
                    plant => {
                        return { value: plant.id, label: plant.plant_alias }
                    }
                );
                setplant(plant);
            }
        )
        .catch(() => setplant([]));
    }, []);

    React.useEffect(() => {
        getAllVendors(cookies)
        .then (
            vendorList => {
                const vendor = vendorList.vendor_list.filter(obj => obj.status).map(
                    vendor => {
                        return { value: vendor.id, label: vendor.entity_name }
                    }
                );
                setvendor(vendor);
            }
        )
        .catch(() => setvendor([]));
    }, []);
    
    React.useEffect(() => {
        getAllTax(cookies)
        .then (
            TaxList => {
                const taxes = TaxList.tax_list.filter(obj => obj.status).map(
                    tax => {
                        return { value: tax.id, label: tax.name }
                    }
                );
                setTaxes(taxes);
            }
        )
        .catch(() => setTaxes([]));
    }, []);

    React.useEffect(() => {
        var today = new Date().getFullYear()+'-'+("0"+(new Date().getMonth()+1)).slice(-2)+'-'+("0"+new Date().getDate()).slice(-2)
        setInputs(values => ({...values, ['grn_date']: today,['weighment_slip_date']:today,['lr_dt']:today,['dc_dt']:today}))
    }, []);
    
    React.useEffect(() => {
        const today = new Date().toISOString().split("T")[0];
        setMaxDate(today);
    }, []);

    React.useEffect(() => {
        getAllProducts(cookies)
        .then (
            productList => {
                const products = productList.product_list.filter(obj => obj.status);
                setProducts(products.map(product =>{
                    return{ value: product.id, label: product.name, unit: product.unit?.symbol || ''}
                }));
            }
        )
        .catch(() => setProducts([]));
    }, []);
    
    React.useEffect(() => {
        getAllEquipments(cookies)
        .then (
            equipmentObject => {
                const equipments = equipmentObject.equipment_list.filter(obj => ((obj.equip_type.name === 'TRANSIT MIXER')&& (obj.status) && (obj.is_equip_ready))).map(
                    equipment => {
                        return { value: equipment.id, label: equipment.equip_name }
                    }
                );
                setEquipment(equipments);
            }
        )
        .catch(() => setEquipment([]));
    }, []);

    React.useEffect(() => {
        getCustomerVehicles(cookies)
            .then(response => {
                setCustomerVehicles(mapUniqueSelectOptions(response.customer_vehicles_list));
            })
            .catch(() => setCustomerVehicles([]));
    }, []);

    React.useEffect(() => {
        getTransporterNames(cookies)
            .then(response => {
                setTransporterNames(mapUniqueSelectOptions(response.transporter_names_list));
            })
            .catch(() => setTransporterNames([]));
    }, []);

    const isDirectMode = inputs.receipt_mode === 'direct';

    const parsePoOrderDate = (dateStr) => {
        if (!dateStr) return 0;
        const parts = String(dateStr).split('-');
        if (parts.length === 3) {
            const [d, m, y] = parts.map(Number);
            return new Date(y, m - 1, d).getTime();
        }
        return new Date(dateStr).getTime() || 0;
    };

    const fmtQty3 = (val) => (parseFloat(val) || 0).toFixed(3);

    const buildPurchaseOrderPopupRows = (purchaseOrders) => {
        const sorted = [...purchaseOrders].sort(
            (a, b) => parsePoOrderDate(b.order_date) - parsePoOrderDate(a.order_date)
        );
        const rows = [];
        sorted.forEach(po => {
            (po.order_list || []).forEach(line => {
                const orderQty = parseFloat(line.quantity) || 0;
                const balanceQty = parseFloat(line.balance_qty) || 0;
                const receivedQty = orderQty - balanceQty;
                rows.push({
                    id: po.id,
                    order_no: po.prefix + po.order_no,
                    order_date: po.order_date,
                    vendor_id: po.vendor.name,
                    product: line.product?.name || '',
                    order_qty: fmtQty3(orderQty),
                    rate: fmtQty3(line.rate),
                    received_qty: fmtQty3(receivedQty),
                    balance_qty: fmtQty3(balanceQty),
                });
            });
        });
        return rows;
    };

    const handleReceiptModeChange = (event) => {
        const mode = event.target.value;
        setInputs(values => ({
            ...values,
            receipt_mode: mode,
            company_id: values.company_id || '',
            vendor_id: '',
            purchaseorder_id: '',
            order_no: '',
            order_date: '',
            transporter_mode: '',
        }));
        setSelectedPurchaseOrder({});
        setSelectedVendor({});
        setSelectedTransporter(null);
        setRowsData([]);
    };

    const addDirectLine = () => {
        setRowsData(rows => [...rows, {
            sl_no: rows.length + 1,
            product_id: '',
            tax_id: '',
            unit: '',
            quantity: '',
            rate: 0,
            amount: 0,
            balance_qty: '',
            is_checked: true,
            gross_weight: 0,
            tare_weight: 0,
            net_weight: 0,
            deduction_qty: 0,
            accepted_qty: 0,
            dc_qty: 0,
            received_qty: 0,
            difference_qty: 0,
            taxable_amount: 0,
            user_remarks: '',
        }]);
    };

    const removeDirectLine = (index) => {
        setRowsData(rows => rows
            .filter((_, rowIndex) => rowIndex !== index)
            .map((row, rowIndex) => ({ ...row, sl_no: rowIndex + 1 }))
        );
    };

    const buildDetailPayload = (grn_detail) => {
        const line = { ...grn_detail };
        if (!hasGrnWeighment(line)) {
            syncGrnLineWithoutWeighment(line);
        }
        const base = {
            gross_weight: toGrnFloat(line.gross_weight),
            tare_weight: toGrnFloat(line.tare_weight),
            net_weight: toGrnFloat(line.net_weight),
            dc_qty: toGrnFloat(line.dc_qty),
            deduction_qty: toGrnFloat(line.deduction_qty),
            received_qty: toGrnFloat(line.received_qty),
            accepted_qty: toGrnFloat(line.accepted_qty),
            user_remarks: line.user_remarks,
        };
        if (isDirectMode) {
            return {
                ...base,
                product_id: parseInt(grn_detail.product_id),
                rate: parseFloat(grn_detail.rate),
                tax_id: parseInt(grn_detail.tax_id),
            };
        }
        return {
            ...base,
            po_detail_id: parseInt(grn_detail.id),
        };
    };

    const handleSubmit=(event)=> {
        event.preventDefault()
        const hasChecked = rowsData.some(row => row.is_checked);
        const directFieldsOk = !isDirectMode || (inputs.company_id && inputs.vendor_id);
        const poFieldsOk = isDirectMode || (inputs.company_id && inputs.purchaseorder_id);
        const transportOk = isDirectMode
            ? (!inputs.transporter_mode || (
                inputs.transporter_name && inputs.in_time && inputs.out_time
                && (inputs.transporter_mode === 'own' ? selectedVehicle : inputs.vehicle_others)
            ))
            : (inputs.transporter_name && inputs.transporter_mode && inputs.in_time && inputs.out_time
                && (inputs.transporter_mode === 'own' ? selectedVehicle : inputs.vehicle_others));
        const coreFieldsOk = inputs.plant_id && inputs.dc_no && inputs.dc_dt && inputs.grn_date;
        if (coreFieldsOk && transportOk && hasChecked && directFieldsOk && poFieldsOk) {
            Swal.fire({title: 'Do you want to save?',  
            showCancelButton: true,  
            confirmButtonText: `Yes`,  
            cancelButtonText: `No`,
            }).then((result) => {  
            if (result.isConfirmed) 
            {
                const EMPTY_STRING = '';
                createGoodsReceiptNote(cookies, {
                        "plant_id": parseInt(inputs.plant_id),
                        "receipt_mode": inputs.receipt_mode,
                        "company_id": parseInt(inputs.company_id),
                        ...(isDirectMode ? {
                            "vendor_id": parseInt(inputs.vendor_id),
                            "is_tax_included": inputs.is_tax_included ? 1 : 0,
                        } : {}),
                        "goods_receipt_note_no": inputs.goods_receipt_number,
                        "goods_receipt_note_date": inputs.grn_date ? getDisplayDate(inputs.grn_date) : EMPTY_STRING,
                        "goods_receipt_note_time": getCurrentTime(),
                        "prefix": inputs.prefix,
                        "transporter_name": inputs.transporter_name,
                        "transport_mode": inputs.transporter_mode,
                        "vehicle_id": inputs.transporter_mode === 'own' && selectedVehicle?.value
                            ? (parseInt(selectedVehicle.value, 10) || '')
                            : '',
                        "vehicle_others":inputs.transporter_mode === 'customer'?inputs.vehicle_others:'',
                        "driver_name": inputs. driver_name,
                        "driver_mobile_no":inputs.driver_mobile_no,
                        "dc_no":inputs.dc_no,
                        "dc_dt":inputs.dc_dt? getDisplayDate(inputs.dc_dt) : EMPTY_STRING,
                        "other_doc_no": inputs.other_doc_no || '',
                        "other_doc_dt": inputs.other_doc_dt ? getDisplayDate(inputs.other_doc_dt) : EMPTY_STRING,
                        "measurement_taken_by": inputs.measurement_taken_by,
                        "authorised_by": inputs.authorised_by,
                        "received_by": inputs.received_by,
                        "out_time": inputs.out_time,
                        "in_time": inputs.in_time,
                        "weighment_name": inputs. weighment_name,
                        "weighment_slip_no": inputs.weighment_slip_no,
                        "weighment_slip_date":inputs.weighment_slip_date? getDisplayDate(inputs.weighment_slip_date) : EMPTY_STRING,
                        "weighment_slip_time": inputs. weighment_slip_time,
                        "user_remarks": inputs.remarks,
                        "lr_no":inputs.lr_no,
                        "lr_dt":inputs.lr_dt? getDisplayDate(inputs.lr_dt) : EMPTY_STRING,
                        "detail_list": rowsData.filter(obj => (obj.is_checked)).map(buildDetailPayload)
                })
                .then(async (response) => {
                    const grnId = response && response.data && response.data.id;
                    const pending = grnDocuments.filter((doc) => doc.isPending && doc.file);
                    if (grnId && pending.length) {
                        try {
                            await uploadPendingGrnDocuments(cookies, grnId, pending);
                        } catch (uploadError) {
                            Swal.fire(
                                'GRN saved',
                                'Some documents could not be uploaded. Open this GRN from the list to attach them again.',
                                'warning',
                            );
                            Reload();
                            return;
                        }
                    }
                    Swal.fire("Saved!", "", "success");
                    Reload();
                })
                .catch((error) =>
                {
                    // console.log(error.response.data);
                    displayError(error.response.data,"Save Failed");
                })
              
            }
            else if (result.isDismissed) 
            {    
                Swal.fire('Not saved', '', 'info')  
            }
            });
        }
        else if(!(hasChecked))
        {
        Swal.fire('Please add atleast one product', '', 'info')   
        }
        else if (isDirectMode && !directFieldsOk)
        {
        Swal.fire('Please select plant and vendor for direct receipt.', '', 'info')
        }
        else if (!isDirectMode && !poFieldsOk)
        {
        Swal.fire('Please select plant and purchase order.', '', 'info')
        }
        else if (!transportOk && !isDirectMode)
        {
        Swal.fire('Please fill transporter details (transporter, mode, vehicle, in/out time).', '', 'info')
        }
        else if (!coreFieldsOk)
        {
        Swal.fire('Please select plant, GRN date, DC no and DC date.', '', 'info')
        }
        else 
        {
        Swal.fire('Please check mandatory fields are filled.', '', 'info')   
        }
    }

    const Reload = () => {
        window.location.reload();
    }
   
    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === "plant_id") {
            setSelectedPurchaseOrder({});
            setSelectedVendor({});
            setRowsData([]);
            if (value) {
                var t = inputs.grn_date
                var moment = require('moment');
                var c=moment(t).format("DD-MM-YYYY");
                getPlantDetails(cookies, value)
                    .then((plantDetail) => {
                        const companyId = plantDetail.company?.id || plantDetail.entity_company_id || '';
                        setCompanyName(plantDetail.company?.name || '');
                        setInputs(values => ({
                            ...values,
                            plant_id: value,
                            company_id: companyId,
                            purchaseorder_id: '',
                            order_no: '',
                            order_date: '',
                            vendor_id: '',
                            transporter_mode: '',
                        }));
                    })
                    .catch((error) => {
                        setCompanyName('');
                        displayError(error.response?.data, "Failed to load plant company");
                        setInputs(values => ({
                            ...values,
                            plant_id: value,
                            company_id: '',
                            purchaseorder_id: '',
                            order_no: '',
                            order_date: '',
                            vendor_id: '',
                            transporter_mode: '',
                        }));
                    });
                getGoodsReceiptnumber(cookies,value,c)
                    .then((response) => {
                        setInputs(values => ({
                            ...values,
                            goods_receipt_prefix: response.prefix + response.goods_receipt_note_no,
                            goods_receipt_number: response.goods_receipt_note_no,
                            prefix: response.prefix
                        }));
                    })
                .catch((error) =>
                {
                    displayError(error.response?.data,"");
                })
            } 
            else {
                setCompanyName('');
                setInputs(values => ({
                    ...values,
                    plant_id: '',
                    company_id: '',
                    purchaseorder_id: '',
                    order_no: '',
                    order_date: '',
                    vendor_id: '',
                    transporter_mode: '',
                    goods_receipt_prefix: '',
                    goods_receipt_number: '',
                    prefix: ''
                }));
            }
            return;
        } 
        else if (name === "grn_date") {
            var t=inputs.plant_id
            var s = value
            var moment = require('moment');
            var d=moment(s).format("DD-MM-YYYY");
            setInputs(values => ({ ...values, [name]: value }));
            if (!t) {
                return;
            }
            getGoodsReceiptnumber(cookies,t,d)
            .then((response) => {
                setInputs(values => ({
                    ...values,
                    goods_receipt_prefix: response.prefix + response.goods_receipt_note_no,
                    goods_receipt_number: response.goods_receipt_note_no,
                    prefix: response.prefix
                }));
            })
            .catch((error) =>
            {
                displayError(error.response?.data,"");
            })
            return;
        }
        setInputs(values => ({ ...values, [name]: value }));
        if (name === 'vendor_id' && value) {
            getVendorDetails(cookies, value)
                .then(vendorObject => setSelectedVendor(vendorObject))
                .catch(() => setSelectedVendor({}));
        }
    }

    const handleChangeTableDetails = (index, evnt) => {
        const { name, value } = evnt.target;
        const rowsInput = [...rowsData];
        rowsInput[index][name] = value;
        if (name === 'gross_weight' || name === 'tare_weight') {
            if (hasGrnWeighment(rowsInput[index])) {
                syncGrnLineWithWeighment(rowsInput[index]);
            }
            let totalNetWeight = 0;
            for (let i = 0; i < rowsData.length; i++) {
                totalNetWeight += parseFloat(rowsInput[i]['net_weight'] || 0);
            }
            setInputs(values => ({
                ...values,
                ['total_net_weight']: totalNetWeight
            }));
        } else if (name === 'deduction_qty') {
            if (hasGrnWeighment(rowsInput[index])) {
                syncGrnLineWithWeighment(rowsInput[index]);
            } else {
                syncGrnLineWithoutWeighment(rowsInput[index]);
            }
            const acceptedQty = parseFloat(rowsInput[index]['accepted_qty'] || 0);
            const balanceQty = parseFloat(rowsInput[index]['balance_qty']);
            if (acceptedQty > balanceQty) {
                Swal.fire('Accepted quantity cannot be greater than balance quantity!');
            }
        } else if (name === 'accepted_qty') {
            if (!hasGrnWeighment(rowsInput[index])) {
                syncGrnLineWithoutWeighment(rowsInput[index]);
            } else {
                rowsInput[index]['taxable_amount'] = (value * (parseFloat(rowsInput[index]['rate']))).toFixed(3);
            }
        }
        else if (name === 'dc_qty') {
            const dc_qty =  value;
            const received_qty =  rowsInput[index]['received_qty'];
            rowsInput[index]['difference_qty'] = (parseFloat(dc_qty) - parseFloat(received_qty)).toFixed(3);
        }
        else if(name=== 'is_checked'){
            const is_checked = evnt.target.checked;
            rowsInput[index]['is_checked'] = is_checked;
        }
        else if (name === 'product_id' && isDirectMode) {
            const selectedProduct = products.find(item => String(item.value) === String(value));
            rowsInput[index]['unit'] = selectedProduct ? selectedProduct.unit : '';
        }
        else if ((name === 'rate' || name === 'accepted_qty') && isDirectMode) {
            const qty = parseFloat(rowsInput[index]['accepted_qty'] || rowsInput[index]['received_qty'] || 0);
            const rate = parseFloat(rowsInput[index]['rate'] || 0);
            rowsInput[index]['amount'] = (qty * rate).toFixed(3);
            rowsInput[index]['taxable_amount'] = rowsInput[index]['amount'];
        }
        setRowsData(rowsInput);
    }
    
    const handleChangePurchaseOrderDetails = (value, event) => {
        const purchaseOrderId = value;
        const propertyName = 'purchaseorder_id';
        if (purchaseOrderId) {
            const selectedPo = allPurchaseOrders.filter(obj => obj.id == purchaseOrderId)[0];
            if (!selectedPo) {
                setShowModal(false);
                return;
            }
            if (String(selectedPo.plant?.id) !== String(inputs.plant_id)) {
                Swal.fire('Selected purchase order does not belong to the chosen plant.', '', 'warning');
                setShowModal(false);
                return;
            }
            if (inputs.company_id && String(selectedPo.company?.id) !== String(inputs.company_id)) {
                Swal.fire('Selected purchase order does not belong to the plant company.', '', 'warning');
                setShowModal(false);
                return;
            }
            setSelectedPurchaseOrder(selectedPo);
            if (selectedPo) { 
                setInputs(values => ({
                    ...values,
                    [propertyName]: purchaseOrderId,
                    ['transporter_mode']: selectedPo.transport_mode,
                    ['order_no']:selectedPo.prefix+selectedPo.order_no,
                    ['order_date']:getDisplayDate(selectedPo.order_date),
                    ['vendor_id']:selectedPo.vendor.id,
                }));
                getVendorDetails(cookies, selectedPo.vendor.id)
                .then(vendorObject => {
                    // Set the details of the vendor in the state
                    setSelectedVendor(vendorObject);
                });
            }
            // console.log(JSON.stringify(selectedPo)+"selectedPo")
            setRowsData(selectedPo.order_list);
            setIsLoading(true);
            const a=(selectedPo.order_list.map((quolist,index)=>({...quolist,sl_no: index+1,
                        tax_id:quolist.tax.id,product_id:quolist.product.id,unit:quolist.product.unit.symbol,balance_qty:quolist.balance_qty,accepted_qty:0,taxable_amount:0,id:quolist.id,is_checked:false,gross_weight:0,tare_weight:0,net_weight:0,deduction_qty:0,
                        dc_qty:0,received_qty:0,difference_qty:0})));
            setRowsData(a) 
        } 
        setShowModal(false);
    }

    const ShowOrderDetails = () => {
        if (!inputs.plant_id) {
            Swal.fire('Please select plant first.', '', 'info');
            return;
        }
        setIsLoading(true);
        getpurchaseorderforgrn(cookies)
        .then (purchaseorderList => {
            const filtered = purchaseorderList.purchase_order_list.filter(
                obj => obj.status
                    && String(obj.plant?.id) === String(inputs.plant_id)
                    && (!inputs.company_id || String(obj.company?.id) === String(inputs.company_id))
            );
            if (!filtered.length) {
                setIsLoading(false);
                Swal.fire('No purchase orders found for the selected plant.', '', 'info');
                return;
            }
            setAllPurchaseOrders(filtered);
            const tableData = buildPurchaseOrderPopupRows(filtered);
                setData({
                    total: data.total,
                    records: tableData
                });
                setIsLoading(false);
                setShowModal(true)
        })
        .catch((error) => {
            setIsLoading(false);
            displayError(error.response?.data, 'Failed to load purchase orders');
        });
    }

    const Close = () => {
        setShowModal(false)
    }
    const columns =
        useMemo(
            () => [
                {
                    fieldName: "id",
                    headerName: "ROW_ACTIONS",
                    size:40
                },
                {
                    fieldName: 'order_no',
                    headerName: 'Order No',
                    size:40
                },
                {
                    fieldName: 'order_date',
                    headerName: 'Order Date',
                    size:50
                },
                {
                    fieldName:"vendor_id",
                    headerName: 'Vendor',
                    size:180
                },
                {
                    fieldName: 'product',
                    headerName: 'Product',
                    size:160
                },
                {
                    fieldName: 'order_qty',
                    headerName: 'Order Qty',
                    size:90
                },
                {
                    fieldName: 'rate',
                    headerName: 'Rate',
                    size:80
                },
                {
                    fieldName: 'received_qty',
                    headerName: 'Received Qty',
                    size:100
                },
                {
                    fieldName: 'balance_qty',
                    headerName: 'Balance Qty',
                    size:100
                }
            ],
        [],);

    const showplantdetails=()=>{ 
        if (!inputs.plant_id) {
            // If no plant is selected, do nothing
            return;
        }
        getPlantDetails(cookies,inputs.plant_id)  //get plant list
        .then(plant =>{
            Swal.fire({
                html: getHTMLForSummaryPopup(
                    'PLANT DETAILS',
                    [
                        { label: 'ADDRESS', value: plant.address_1 },
                        { value: plant.address_2 },
                        { value: plant.address_3 },
                        { value: plant.pincode },
                        { label: 'GST', value: plant.gst_no },
                        { label: 'PAN', value: plant.pan_no },
                    ]
                )
            }, '', 'info');  
        })
    }

    const showVendorDetails = () => {
        if (!selectedVendor || !selectedVendor.id) {
            // If no vendor is selected, do nothing
            return;
        }
        Swal.fire({
            html: getHTMLForSummaryPopup(
                'VENDOR DETAILS',
                [
                    { label: 'ADDRESS', value: selectedVendor.address_1 },
                    { value: selectedVendor.address_2 },
                    { value: selectedVendor.address_3 },
                    { label: 'GST', value: selectedVendor.gst_no },
                    { label: 'PAN', value: selectedVendor.pan_no },
                    { label: 'CONTACT PERSON NAME', value: selectedVendor.contact_person },
                    { label: 'DESIGNATION', value: selectedVendor.contact_designation }
                ]
            )
        }, '', 'info');
    }

    const Cancel = () => {
        setCompanyName('');
        setInputs({
            company_id:'',
            vendor_id:'',
            transporter_name:'',
            transporter_mode:'',
            vehicle_id:'',
            vehicle_others:'',
            driver_name:'',
            driver_mobile_no:'',
            in_time:'',
            out_time:'',
            weighment_name:'',
            weighment_slip_no:'',
            weighment_slip_date:'',
            weighment_slip_time:'',
            measurement_taken_by:'',
            authorised_by:'',
            received_by:'',
            lr_no:'',
            lr_dt:'',
            dc_no:'',
            dc_dt:'',
            other_doc_no:'',
            other_doc_dt:'',
            transport_mode:'',
            is_tax_included:'',
            pay_terms:'',
            grn_no:'',
            grn_date:'',
            order_no:'',
            order_date:'',
            prefix:'',
            status:''
        })
        setSelectedTransporter(null);
        setSelectedOption(null);
        setSelectedVehicle(null);
        setRowsData([])
    }
    
    const navigate = useNavigate();
    
    const view = () => {
        navigate('/GoodsReceiptNoteTable')
    }

    const Home = () => {
        navigate('/Home')
    }

    const onVehicleSelect = (selected) => {
        setSelectedVehicle(selected);
    };
    
    const handleEditIconClick = () => {
        if ((inputs.purchaseorder_id && selectedPurchaseOrder) || isDirectMode) {
            setShowModal2(true); 
        } else {
            Swal.fire('Please select plant and purchase order first.', '', 'info');
        }
    };

    const handleWeighmentIconClick = () => {
        console.log("Inputs before opening modal:", inputs);
        Swal.fire({
            title: 'Weighment Details',
            html:
            '<label for="weighment_name" class="form-group col-sm-5 text-right">Weighment Name</label>' +
            `<input type="text" id="weighment_name" class="form-group col-sm-5 text-left" value="${inputs.weighment_name || ''}" >` +
            '<label for="weighment_slip_no" class="form-group col-sm-5 text-right">Weighment no</label>' +
            `<input type="text" id="weighment_slip_no" class="form-group col-sm-5 text-left" value="${inputs.weighment_slip_no || ''}" >` +
            '<label for="weighment_slip_date" class="form-group col-sm-5 text-right">Date</label>' +
            `<input type="date" id="weighment_slip_date" class="form-group col-sm-5 text-left"  max="${maxDate}" value="${inputs.weighment_slip_date || ''}" >`+
            '<label for="weighment_slip_time" class="form-group col-sm-5 text-right">Time</label>' +
            `<input type="time" id="weighment_slip_time" class="form-group col-sm-5 text-left" value="${inputs.weighment_slip_time || ''}" >`,
        }).then((result) => {
            if (result.isConfirmed) {
                    const weighmentname = document.getElementById('weighment_name').value;
                    const weighment_slip_no = document.getElementById('weighment_slip_no').value;
                    const weighment_slip_date = document.getElementById('weighment_slip_date').value;
                    const weighment_slip_time = document.getElementById('weighment_slip_time').value;
                    setInputs(values => ({
                        ...values,
                        weighment_name: weighmentname,
                        weighment_slip_no: weighment_slip_no,
                        weighment_slip_date: weighment_slip_date,
                        weighment_slip_time: weighment_slip_time
                    }));
            }
        });
    };

    const handlemeasurementIconClick = () => {
        Swal.fire({
            title: 'Measurement Details',
            html:
            '<label for="measurement_taken_by" class="form-group col-sm-5 text-right">Measurement taken by</label>' +
            `<input type="text" id="measurement_taken_by" class="form-group col-sm-5 text-left" value="${inputs.measurement_taken_by || ''}" >` +
            '<label for="authorised_by" class="form-group col-sm-5 text-right">Authorised by</label>' +
            `<input type="text" id="authorised_by" class="form-group col-sm-5 text-left" value="${inputs.authorised_by || ''}" >`+
            '<label for="received_by" class="form-group col-sm-5 text-right">Received by</label>' +
            `<input type="text" id="received_by" class="form-group col-sm-5 text-left" value="${inputs.received_by || ''}">`,
        }).then((result) => {
            if (result.isConfirmed) {
                const measurement_taken_by = document.getElementById('measurement_taken_by').value;
                const authorised_by = document.getElementById('authorised_by').value;
                const received_by = document.getElementById('received_by').value;
                setInputs(values => ({
                            ...values,
                            measurement_taken_by: measurement_taken_by,
                            authorised_by: authorised_by,
                            received_by:received_by
                        }));
                // console.log("Measurement taken by:", measurement_taken_by);
                // console.log("Authorised by:",authorised_by);
                // console.log("Received by:",received_by);
            }
        });
    };

    const handleChangeTransporter = (newValue) => {
        setSelectedTransporter(newValue);
        setInputs(values => ({
            ...values,
            transporter_name: newValue ? newValue.value : '',
        }));
    };

    const handleChangevehicle = (newValue) => {
        setSelectedOption(newValue);
        setInputs(values => ({
            ...values,
            vehicle_others: newValue ? newValue.value : '',
        }));
    };
        
    return(
        <>
            <div id="outer-container" className="App" >
                <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} /> 
                <ErrorToast/>
                <div id="page-wrap">
                    <form onSubmit={handleSubmit} >
                        <div className="premium-page-header-wrap">
              <PremiumPageHeader
                module="STORE"
                title="Goods Receipt Note"
                subtitle="Record materials received against purchase orders."
                modeLabel="ADD MODE"
              />
            </div>
                        
                        <FloatingControls tableLink="/GoodsReceiptNoteTable" onCancel={Cancel} enableCancel={true}/>
                        
                        <div className="form-content-wrap">
                            <Row className="form-equal-height-row no-gutters">
                                <Col xl={6} lg={12} md={12}>
                                    <div className="modal" tabIndex="-1" style={{ display: showModal ? 'block' : 'none' }}>
                                        <div className="modal-dialog modal-xl" style={{height: "500px"}} >
                                            <div className="modal-content">
                                                <div className="modal-body display">
                                                    <div className="container item-list-table-container">
                                                        <ReactTablePopUpSubmitWrapper
                                                            title='List of Group Form'
                                                            columns={columns}
                                                            data={data.records}
                                                            onRowSubmit={handleChangePurchaseOrderDetails}
                                                            isLoading={isLoading}
                                                            onClose = {Close}
                                                        />
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill">
                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="receipt_mode" className="form-group col-sm-4 text-right mb-0">Receipt Type</label>
                                            <select id="receipt_mode" name="receipt_mode" className="form-control col-sm-7 mandatory-form-control" value={inputs.receipt_mode || 'po'} onChange={handleReceiptModeChange}>
                                                <option value="po">Against Purchase Order</option>
                                                <option value="direct">Direct Receipt (without PO)</option>
                                            </select>
                                        </div>

                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="plant_id" className="form-group col-sm-4 text-right mb-0">Plant</label>
                                            <select id="plant_id" name="plant_id" className="form-control col-sm-7 browser-default custom-select mandatory-form-control" required onChange={handleChange} value={inputs.plant_id || ""}>
                                                <option value="">Select Plant</option>
                                                {plant.map((item) => (
                                                    <option key={item.value}value={item.value}>{item.label} </option>
                                                ))} 
                                            </select>
                                            <SummaryIcon onClickHandler={showplantdetails}/>
                                        </div>

                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="company_name" className="form-group col-sm-4 text-right mb-0">Company</label>
                                            <input
                                                type="text"
                                                id="company_name"
                                                className="form-control col-sm-7"
                                                value={companyName || ''}
                                                readOnly
                                                style={{ backgroundColor: 'white', cursor: 'not-allowed' }}
                                                placeholder="Auto from plant"
                                            />
                                        </div>

                                        <h4 className='col-sm-11'><b>Vendor Details</b></h4><br/><br/>

                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="vendor_id" className="form-group col-sm-4 text-right mb-0">Vendor Name</label>
                                            <select id="vendor_id" name="vendor_id" className="form-control col-sm-7 browser-default"  value={inputs.vendor_id || ""} disabled={!isDirectMode} onChange={handleChange} style={{cursor: isDirectMode ? "pointer" : "not-allowed"}}>
                                                <option value="">Select Vendor  Name</option>
                                                {vendor.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </select>
                                            <SummaryIcon onClickHandler={showVendorDetails}/>
                                        </div>

                                        <div className="w-100 d-flex flex-wrap align-items-center justify-content-between mb-1" style={{ gap: '4px 8px' }}>
                                            <span className="d-inline-flex align-items-center">
                                                <label htmlFor="transporter" className="mb-0 mr-1">Transporter</label>
                                                <EditSharpIcon
                                                    onClick={handleEditIconClick}
                                                    color="error"
                                                    sx={{ cursor: 'pointer' }}
                                                />
                                            </span>
                                            <span className="d-inline-flex align-items-center">
                                                <label htmlFor="weighment" className="mb-0 mr-1">Weighment</label>
                                                <EditSharpIcon
                                                    color="#1565c0"
                                                    onClick={handleWeighmentIconClick}
                                                    sx={{ cursor: 'pointer' }}
                                                />
                                            </span>
                                            <span className="d-inline-flex align-items-center">
                                                <label htmlFor="measurment" className="mb-0 mr-1">Measurement</label>
                                                <EditSharpIcon
                                                    color="#1565c0"
                                                    sx={{ cursor: 'pointer' }}
                                                    onClick={handlemeasurementIconClick}
                                                />
                                            </span>
                                            <span className="d-inline-flex align-items-center">
                                                <label htmlFor="upload_centre" className="mb-0 mr-1" style={{ whiteSpace: 'nowrap' }}>Upload Centre</label>
                                                <EditSharpIcon
                                                    onClick={() => setShowUploadCentre(true)}
                                                    sx={{
                                                        cursor: 'pointer',
                                                        color: grnDocuments.length ? '#1565c0' : '#d32f2f',
                                                    }}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </Col>

                                <Col xl={6} lg={12} md={12}>
                                    <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill">
                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="order_no" className="form-group col-sm-4 text-left mb-0" style={{ whiteSpace: 'nowrap' }}>PO No.</label>
                                            <input type="text" className={`form-control ${isDirectMode ? 'col-sm-7' : 'col-sm-6'}`} id="order_no" value={inputs.order_no || ""} disabled={true} name="order_no" style={{ cursor: 'not-allowed' }} />
                                            {!isDirectMode && <QuestionIcon onClickHandler={ShowOrderDetails} />}
                                        </div>

                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="order_date" className="form-group col-sm-4 text-left mb-0">Date</label>
                                            <input required type="date" id="order_date" name="order_date" className="form-control col-sm-7" disabled={true} value={inputs.order_date || ""} style={{ cursor: 'not-allowed' }} />
                                        </div>

                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="grn_no" className="form-group col-sm-4 text-left mb-0" style={{ whiteSpace: 'nowrap' }}>GRN No.</label>
                                            <input type="text" className="form-control col-sm-7" id="grn_no" value={inputs.goods_receipt_prefix || ""} style={{ cursor: 'not-allowed' }} disabled={true} name="goods_receipt_prefix" />
                                        </div>

                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="grn_date" className="form-group col-sm-4 text-left mb-0">Date</label>
                                            <input required type="date" id="grn_date" name="grn_date" onChange={handleChange} className="form-control col-sm-7 mandatory-form-control" value={inputs.grn_date || ""} max={maxDate} />
                                        </div>

                                        <h4 className='col-sm-11'><b>Supplier Document Details </b></h4><br/><br/>

                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="dc_no" className="form-group col-sm-4 text-left mb-0">DC No</label>
                                            <input type="text" id="dc_no" className="form-control col-sm-7 mandatory-form-control" value={inputs.dc_no || ''} onChange={handleChange} required name="dc_no"/>
                                        </div>

                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="dc_dt" className="form-group col-sm-4 text-left mb-0">DC Date</label>
                                            <input type="date" id="dc_dt" className="form-control col-sm-7 mandatory-form-control" value={inputs.dc_dt || ''} onChange={handleChange} name="dc_dt" required max={maxDate}/>
                                        </div>

                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="other_doc_no" className="form-group col-sm-4 text-left mb-0">Other Doc No</label>
                                            <input type="text" id="other_doc_no" className="form-control col-sm-7" value={inputs.other_doc_no || ''} onChange={handleChange} name="other_doc_no"/>
                                        </div>

                                        <div className="w-100 d-flex flex-wrap align-items-center mb-1">
                                            <label htmlFor="other_doc_dt" className="form-group col-sm-4 text-left mb-0">Other Doc Date</label>
                                            <input type="date" id="other_doc_dt" className="form-control col-sm-7" value={inputs.other_doc_dt || ''} onChange={handleChange} name="other_doc_dt" max={maxDate}/>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue table-responsive">
                                <br/>
                                <table className="table order-list" id="myTable" style={{textAlign:"center",borderRadius:"10px",backgroundColor:"RGB(188,232,253)"}}>
                                    <thead>
                                        <tr>
                                            <th className="form-group col-sm-1 text-left">Action</th>
                                            <th colSpan="1">S.No.</th>
                                            <th colSpan="1">Product</th>
                                            <th colSpan="1">Unit</th>
                                            <th colSpan="1">Order Qty.</th>
                                            <th colSpan="1">Rate / M3 </th>
                                            <th colSpan="1">Amount</th>
                                            <th colSpan="1">Balance Qty</th>
                                            <th colSpan="1">DC Qty</th>
                                            <th colSpan="1">Gross Weight</th>
                                            <th colSpan="1">Tare Weight</th>  
                                            <th colSpan="1">Net Weight</th> 
                                            <th colSpan="1">Deduction Weight</th> 
                                            <th colSpan="1">Accepted Qty</th>  
                                            <th colSpan="1">Total Received Qty</th>
                                            <th colSpan="1">Difference Qty</th>
                                            <th colSpan="1">Taxable Amount</th>
                                            <th colSpan="1">Tax</th>
                                            <th colSpan="1">Remarks</th> 
                                        </tr>
                                    </thead>  
                                    <tbody >
                                        <TableRowsGRN
                                            rowsData={rowsData}
                                            handleChangeTableDetails={handleChangeTableDetails}
                                            products={products}
                                            taxes={taxes}
                                            isDirectMode={isDirectMode}
                                            onAddRow={addDirectLine}
                                            onRemoveRow={removeDirectLine}
                                        />
                                    </tbody>
                                </table> 
                            </div>
                            
                            <div className="form-row table-bordered shadow p-2 my-2  border-secondary p-2 mb-3 form-control-panel ">
                                <label htmlFor="remarks" className="form-group col-sm-2 text-right">Remarks</label>
                                <textarea rows="2" cols="50" className="form-control col-sm-10" id="remarks" name="remarks" onChange={handleChange} value={inputs.remarks || ""}></textarea>
                            </div>
                        </div> 

                        <div className="footer text-center">
                            <Button type="submit" className="btn btn-twitter" style={{ width: "80px", fontWeight: "bold" }} >Save</Button>
                            <Button type="reset" className="btn btn-twitter" style={{ width: "80px", fontWeight: "bold" }} onClick={Cancel}>Cancel</Button>
                            <Button className="btn btn-twitter" type="button" style={{ width: "80px", fontWeight: "bold" }} onClick={view}>View</Button>
                            <Button className="btn btn-twitter" type="button" style={{ width: "80px", fontWeight: "bold" }} onClick={Home}>Home</Button>
                        </div>
                    </form>

                    <Modal isOpen={showModal2} toggle={() => setShowModal2(false)} centered size="lg" backdrop="static">
                        <ModalHeader toggle={() => setShowModal2(false)}>Transporter Details</ModalHeader>
                        <ModalBody>
                            <div className="w-100 d-flex flex-wrap align-items-center mb-2">
                                <label htmlFor="transporter_name" className="form-group col-sm-4 text-right mb-0">Transporter Name</label>
                                <div className="col-sm-7 px-0">
                                    <CreatableSelect
                                        isClearable
                                        isSearchable
                                        id="transporter_name"
                                        className="mandatory-form-control"
                                        options={transporterNames}
                                        value={selectedTransporter}
                                        onChange={handleChangeTransporter}
                                    />
                                </div>
                            </div>

                            <div className="w-100 d-flex flex-wrap align-items-center mb-2">
                                <label htmlFor="transporter_mode" className="form-group col-sm-4 text-right mb-0">Transport Mode</label>
                                <select id="transporter_mode" className="form-control col-sm-7 mandatory-form-control" value={inputs.transporter_mode || ''} name="transporter_mode" onChange={handleChange}>
                                    {isDirectMode && (
                                        <>
                                            <option value="">Please select</option>
                                            <option value="own">Own</option>
                                            <option value="customer">Vendor</option>
                                        </>
                                    )}
                                    {!isDirectMode && selectedPurchaseOrder.transport_mode === 'own' && (
                                        <option value="own">Own</option>
                                    )}
                                    {!isDirectMode && selectedPurchaseOrder.transport_mode === 'customer' && (
                                        <option value="customer">Vendor</option>
                                    )}
                                    {!isDirectMode && selectedPurchaseOrder.transport_mode === 'own/customer' && (
                                        <>
                                            <option value="">Please select</option>
                                            <option value="own">Own</option>
                                            <option value="customer">Vendor</option>
                                        </>
                                    )}
                                </select>
                            </div>

                            {inputs.transporter_mode === 'own' && (
                                <div className="w-100 d-flex flex-wrap align-items-center mb-2">
                                    <label htmlFor="vehicle_id" className="form-group col-sm-4 text-right mb-0">Vehicle Id</label>
                                    <div className="col-sm-7 px-0">
                                        <Select
                                            id="vehicle_id"
                                            className="mandatory-form-control"
                                            options={equipments}
                                            isSearchable={true}
                                            value={selectedVehicle}
                                            onChange={onVehicleSelect}
                                        />
                                    </div>
                                </div>
                            )}

                            {inputs.transporter_mode === 'customer' && (
                                <div className="w-100 d-flex flex-wrap align-items-center mb-2">
                                    <label htmlFor="vehicle_others" className="form-group col-sm-4 text-right mb-0">Vehicle others</label>
                                    <div className="col-sm-7 px-0">
                                        <CreatableSelect
                                            isClearable
                                            isSearchable
                                            onChange={handleChangevehicle}
                                            options={customerVehicles}
                                            value={selectedOption}
                                            className="mandatory-form-control"
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="w-100 d-flex flex-wrap align-items-center mb-2">
                                <label htmlFor="driver_name" className="form-group col-sm-4 text-right mb-0">Driver Name</label>
                                <input type="text" id="driver_name" className="form-control col-sm-7" value={inputs.driver_name || ''} onChange={handleChange} name="driver_name"/>
                            </div>

                            <div className="w-100 d-flex flex-wrap align-items-center mb-2">
                                <label htmlFor="driver_mobile_no" className="form-group col-sm-4 text-right mb-0">Driver Phone no</label>
                                <input type="text" id="driver_mobile_no" className="form-control col-sm-7" value={inputs.driver_mobile_no || ''} onChange={handleChange} name="driver_mobile_no"/>
                            </div>

                            <div className="w-100 d-flex flex-wrap align-items-center mb-2">
                                <label htmlFor="in_time" className="form-group col-sm-4 text-right mb-0">In Time</label>
                                <input type="time" id="in_time" className="form-control col-sm-7 mandatory-form-control" value={inputs.in_time || ''} onChange={handleChange} name="in_time"/>
                            </div>

                            <div className="w-100 d-flex flex-wrap align-items-center mb-2">
                                <label htmlFor="out_time" className="form-group col-sm-4 text-right mb-0">Out Time</label>
                                <input type="time" id="out_time" className="form-control col-sm-7 mandatory-form-control" value={inputs.out_time || ''} onChange={handleChange} name="out_time"/>
                            </div>

                            <div className="w-100 d-flex flex-wrap align-items-center mb-2">
                                <label htmlFor="lr_no" className="form-group col-sm-4 text-right mb-0">Lr no</label>
                                <input type="text" id="lr_no" className="form-control col-sm-7" value={inputs.lr_no || ''} onChange={handleChange} name="lr_no"/>
                            </div>

                            <div className="w-100 d-flex flex-wrap align-items-center mb-2">
                                <label htmlFor="lr_dt" className="form-group col-sm-4 text-right mb-0">Lr dt</label>
                                <input type="date" id="lr_dt" className="form-control col-sm-7" value={inputs.lr_dt || ''} onChange={handleChange} name="lr_dt"/>
                            </div>
                        </ModalBody>
                        <ModalFooter className="justify-content-center">
                            <Button color="secondary" type="button" onClick={() => setShowModal2(false)}>Close</Button>
                        </ModalFooter>
                    </Modal>
                    <GrnUploadCentreModal
                        isOpen={showUploadCentre}
                        toggle={() => setShowUploadCentre(false)}
                        cookies={cookies}
                        documents={grnDocuments}
                        onDocumentsChange={setGrnDocuments}
                    />
                </div>
            </div>
        </>
      )
}
export default GoodsReceiptNote